import styleInject from '../../external/style-inject/dist/style-inject.es.js';

var css_248z = ".PaymentMethodCard-module_paymentMethodCard__pT57b {\n  display: flex;\n  justify-content: space-between;\n}\n.PaymentMethodCard-module_paymentMethodCard__pT57b button {\n  width: auto;\n  min-width: 0;\n  border: none;\n  padding: 0;\n}\n.PaymentMethodCard-module_paymentMethodCard__pT57b button:hover, .PaymentMethodCard-module_paymentMethodCard__pT57b button:focus {\n  color: #00a6eb;\n  background-color: transparent;\n  outline: 0;\n}";
var styles = {"paymentMethodCard":"PaymentMethodCard-module_paymentMethodCard__pT57b"};
styleInject(css_248z);

export { styles as default };
